// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header-sticky[data-v-4c955e98] {\n  z-index: 101;\n}", "",{"version":3,"sources":["webpack://./resources/js/components/header/Header.vue"],"names":[],"mappings":"AACA;EACI,YAAA;AAAJ","sourcesContent":["\n.header-sticky {\n    z-index: 101;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
